import axiosApiClient from '..';
import { handleError, throwErrorIfWrongStatus } from './utils';

const BASE_URL = '/d/withdrawals';

class WithdrawalService {
  fetchWithdrawals = async page => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}?page=${page}`);
      throwErrorIfWrongStatus(response, 200);
      const { data, total } = response.data.data;
      return { data, total };
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching withdrawals.');
    }
  };

  requestWithdrawal = async body => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}`, body);
      throwErrorIfWrongStatus(response, 200);
    } catch (err) {
      throw handleError(err, 'Error occurred while requesting withdrawal.');
    }
  };

  deleteWithdrawalMethod = async body => {
    try {
      const response = await axiosApiClient.put(`${BASE_URL}/method`, body);
      throwErrorIfWrongStatus(response, 200);
      const { withdrawalMethods } = response.data.data;
      return { withdrawalMethods };
    } catch (err) {
      throw handleError(err, 'Error occurred while deleting withdrawal method.');
    }
  };

  createMassPayUser = async body => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/mass-pay/user`, body);
      throwErrorIfWrongStatus(response, 200);
      const { status, activationUrl, email } = response.data.data;
      return { status, activationUrl, email };
    } catch (err) {
      throw handleError(err, 'Error occurred while creating mass pay user.');
    }
  };

  fetchMassPayActivationUrl = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/mass-pay/activation-url`);
      throwErrorIfWrongStatus(response, 200);
      const { status, activationUrl } = response.data.data;
      return { status, activationUrl };
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching mass pay activation url.');
    }
  };

  fetchMassPayCountries = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/mass-pay/countries`);
      throwErrorIfWrongStatus(response, 200);
      const { countries } = response.data.data;
      return { countries };
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching mass pay countries.');
    }
  };
}

export default new WithdrawalService();
